"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToTop = void 0;
const react_intersection_observer_1 = require("react-intersection-observer");
/** A hook for tracking when the scroll-to-top functionality
 * should be available to the user. Checks whether the table
 * is in view before determining whether the first row is also
 * in view. If the first row is in view, then `showScrollToTop`
 * will be `true`.
 *
 * @param {boolean} skip skips checking whether the first row is in view
 * @param {number} tableTop vertical position of the table, used for checking for the first row
 *
 * @returns an object with a table ref, first row ref, and an indicator for showing the scroll-to-top functionality
 */
const useScrollToTop = ({ skip, tableTop }) => {
    const { ref: tableInViewRef, inView: tableInView } = (0, react_intersection_observer_1.useInView)({
        rootMargin: `${-tableTop}px 0px 0px 0px`,
        threshold: 0.05,
        initialInView: false,
        fallbackInView: false,
        skip
    });
    const { ref: topRowInViewRef, inView: topRowInView } = (0, react_intersection_observer_1.useInView)({
        rootMargin: `${-tableTop}px 0px 0px 0px`,
        threshold: 0,
        initialInView: true,
        fallbackInView: true,
        skip: !tableInView && skip
    });
    return {
        tableRef: tableInViewRef,
        topRowRef: topRowInViewRef,
        showScrollToTop: !topRowInView && tableInView
    };
};
exports.useScrollToTop = useScrollToTop;
//# sourceMappingURL=useScrollToTop.js.map